import slick from 'slick-carousel';

$(document).ready(function () {
  $('.clients-carousel').slick({
    infinite: true,
    arrows: false,
    dots: true,
    speed: 300,
    autoplay: true,
    autoplaySpeed: 6000,
    mobileFirst: true,
    fade: true,
    cssEase: 'linear',
    draggable: false,
    swipe: false,
    customPaging: function (slick, i) {
      let dotTitle = slick.$slides.eq(i).find('.slides_dot').data('dotTitle');
      let dotImg = slick.$slides.eq(i).find('.slides_dot').data('dotImg');
      return (
        '<img src="' +
        dotImg +
        '" title="' +
        dotTitle +
        '" alt="' +
        dotTitle +
        '" />'
      );
    },
  });
});
